import { Input, RadioGroup } from '@/components'
import Card from '@/components/Form/Card'
import Title from '@/components/Form/Title'

import { ResponsibleFieldsProps } from './ResponsibleFields.type'

const ResponsibleFields = ({ formData, onChange, loading }: ResponsibleFieldsProps) => (
  <Card title="Dados do Representante">
    <Input
      label="Nome do Representante"
      placeholder="Digite o nome do representante"
      value={formData?.Cliente_REPC2}
      onChange={onChange}
      required
      name="Cliente_REPC2"
    />
    <Input
      label="CPF do Representante"
      placeholder="Digite o CPF representante (somente números)"
      value={formData?.Cliente_CPFREPC2}
      required
      onChange={onChange}
      name="Cliente_CPFREPC2"
    />
    <Input
      label="E-mail do Representante"
      type="email"
      required
      placeholder="Digite o e-mail do representante"
      value={formData?.Cliente_EMAILREPC2}
      onChange={onChange}
      name="Cliente_EMAILREPC2"
    />
    <Input
      label="Telefone do Representante"
      placeholder="Digite o telefone do representante"
      required
      value={formData?.Cliente_TELREPC2}
      onChange={onChange}
      name="Cliente_TELREPC2"
    />

    <RadioGroup
      title="O Responsável e Representante são a mesma pessoa?"
      options={['Sim', 'Não']}
      selectedOption={formData?.Cliente_Responsavel_Representante}
      name="Cliente_Responsavel_Representante"
      onChange={onChange}
      disabled={loading}
    />

    {formData?.Cliente_Responsavel_Representante === 'Não' && (
      <div className="flex flex-col gap-4">
        <div className="mt-6">
          <Title title=" Dados do Responsável" />
        </div>

        <Input
          label="Nome Responsável"
          placeholder="Digite o Nome do Responsável "
          value={formData?.Cliente_RESC2}
          onChange={onChange}
          required
          name="Cliente_RESC2"
        />

        <Input
          label="E-mail Responsável"
          type="email"
          placeholder="Digite o E-mail do Responsável"
          value={formData?.Cliente_EMAILRESC2}
          onChange={onChange}
          required
          name="Cliente_EMAILRESC2"
        />
      </div>
    )}
  </Card>
)

export default ResponsibleFields
